var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tag-filter"
  }, [_c('div', {
    staticClass: "tag-filter__wrapper"
  }, [_c('div', {
    staticClass: "tag-filter__inner-wrapper",
    style: {
      padding: _vm.padding
    }
  }, [_c('div', {
    staticClass: "tag-filter__tag"
  }, [_c('div', {
    staticClass: "tag-filter__tag-el",
    class: {
      'tag-filter__tag-el_active': _vm.value && !_vm.value.value || !_vm.value
    },
    on: {
      "click": function ($event) {
        return _vm.onClick();
      }
    }
  }, [_vm._v("\n          Все\n        ")])]), _vm._v(" "), _vm._l(_vm.list, function (el) {
    return _c('div', {
      key: el.value,
      staticClass: "tag-filter__tag"
    }, [_c('div', {
      staticClass: "tag-filter__tag-el",
      class: {
        'tag-filter__tag-el_active': (_vm.value && _vm.value.value) === el.value
      },
      on: {
        "click": function ($event) {
          return _vm.onClick(el);
        }
      }
    }, [_vm._v("\n          " + _vm._s(el.name) + "\n        ")])]);
  })], 2)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }